import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { JobFunctionService } from './job-function.service';
import { JobFunction } from '@/core/models/job-function.interface';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';

const service = new JobFunctionService();

export interface JobFunctionState {
   jobFunctions?: ApiResource<Array<JobFunction>>;
}

const JobFunctionStore: Module<JobFunctionState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_JOB_FUNCTIONS(state: JobFunctionState, jobFunctions: ApiResource<Array<JobFunction>>) {
         state.jobFunctions = jobFunctions;
      },
      REMOVE_JOB_FUNCTION(state: JobFunctionState, jobFunctionId: number) {
         if (state.jobFunctions) {
            state.jobFunctions.data = state.jobFunctions.data?.filter((jobFunction) => jobFunction.id !== jobFunctionId);
         }
      },
      ADD_JOB_FUNCTION(state: JobFunctionState, jobFunction: JobFunction) {
         if (state.jobFunctions) {
            state.jobFunctions.data?.push(jobFunction);
         }
      },
      UPDATE_JOB_FUNCTION(state: JobFunctionState, jobFunction: JobFunction) {
         if (state.jobFunctions) {
            const index = state.jobFunctions.data?.findIndex((jf) => jf.id === jobFunction.id);
            if (index !== -1) {
               state.jobFunctions.data[index] = jobFunction;
            }
         }
      },
   },
   actions: {
      async getJobFunctions({ commit }, query?: LocationQuery) {
         const jobFunctions = await service.getJobFunctions(query);
         commit('SET_JOB_FUNCTIONS', jobFunctions);
         return jobFunctions;
      },
      async removeJobFunction({ commit }, jobFunctionId: number) {
         await service.deleteJobFunction(jobFunctionId);
         commit('REMOVE_JOB_FUNCTION', jobFunctionId);
      },
      async postJobFunction({ commit }, jobFunction: JobFunction) {
         const response = await service.postJobFunction(jobFunction);
         commit('ADD_JOB_FUNCTION', response);
         return response.data;
      },
      async putJobFunction({ commit }, jobFunction: JobFunction) {
         const response = await service.putJobFunction(jobFunction);
         commit('UPDATE_JOB_FUNCTION', response);
         return response.data;
      },
   },
};

export default JobFunctionStore;
